import { combineReducers } from '@reduxjs/toolkit'
import eventsReducer from './events'
import devicesReducer from './devices'
import customersReducer from './customers'
import userReducer from './user'
import lookupReducer from './lookup'
import threatintelReducer from './threatintel'
import superFeedEventsReducer from './superFeedEvents'
import credentialMonitoringReducer from './credentialMonitoring'
import lmDevicesUsersReducer from './lmDevicesUsers'
import governanceReducer from './governance'
import dataControlEntityReducer from './dataControlEntity'
import policyViolationsReducer from './policyViolations'
import incidentFeedReducer from './incidentFeed'

export default combineReducers({
  events: eventsReducer,
  devices: devicesReducer,
  customers: customersReducer,
  user: userReducer,
  lookup: lookupReducer,
  threatintel : threatintelReducer,
  superFeedEvents: superFeedEventsReducer,
  credentialMonitoring : credentialMonitoringReducer,
  lmDevicesUsers: lmDevicesUsersReducer,
  governance: governanceReducer,
  dataControlEntity: dataControlEntityReducer,
  policyViolations: policyViolationsReducer,
  incidentFeed: incidentFeedReducer,
})
